import { render } from "./ListLibroMayor.vue?vue&type=template&id=6b4f1d6c"
import script from "./ListLibroMayor.vue?vue&type=script&lang=js"
export * from "./ListLibroMayor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__